
import { ApiConfig } from '../constants/apiConfig';
import axios from 'axios';
import { studentAuthorizationHeaders } from './authService';

export async function fetchJadwalHariIni(siswaId) {
  try {
    const response = await axios.get(`${ApiConfig.baseUrl}/jadwals?siswa_id=${siswaId}`, {
      headers: studentAuthorizationHeaders(),
    });

    const data = response.data;
    if (response.status === 200 && data.success) {
      return data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching jadwal:", error);
    return null;
  }
}

export async function checkJadwal() {
  try {
    const response = await axios.post(`${ApiConfig.baseUrl}/jadwals_checks`, {
      siswa_id: localStorage.getItem("user_id"),
    }, { headers: studentAuthorizationHeaders() });
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message || "Gagal memeriksa jadwal.",
    };
  }
}

export async function storeJadwal({ hari, jamMasuk, jamKeluar }) {
  try {
    const response = await axios.post(`${ApiConfig.baseUrl}/jadwals`, {
      siswa_id: localStorage.getItem("user_id"),
      hari,
      jam_masuk: jamMasuk,
      jam_keluar: jamKeluar,
    }, { headers: studentAuthorizationHeaders() });
    return { success: response.data?.success === true, message: response.data?.message || "Jadwal berhasil disimpan." };
  } catch (error) {
    const rawMessage = error.response?.data?.message || error.message || "Gagal menyimpan jadwal.";
    return {
      success: false,
      message: typeof rawMessage === "string" ? rawMessage : Object.values(rawMessage).flat().join(" "),
    };
  }
}
